import React, { useEffect } from 'react'
import { IconMaps } from '@ow/icons'
import { preColor } from './utils/preColor'
import { StyledColorPickerContainer, StyledColorPicker } from './styled'

const Content = ({ setShowColorPicker, onChange, value = null }) => {
  useEffect(() => {
    if (typeof document !== 'object') {
      return null
    }
    const eventfunction = (e) => {
      const arr = e.path.filter((item) => item.id === 'colorPicker')
      if (!arr.length) {
        setShowColorPicker(false)
      }
    }
    document.addEventListener('click', eventfunction)
    return () => {
      document.removeEventListener('click', eventfunction)
    }
  }, [])

  return (
    <StyledColorPickerContainer id="colorPicker">
      <div className="flex justify-between items-center color-header">
        <span>颜色</span>
        <div
          onClick={() => {
            setShowColorPicker(false)
          }}
          className="cursor-pointer"
        >
          <IconMaps type="close" width={12} height={12} size={12} />
        </div>
      </div>
      <StyledColorPicker
        swatches={preColor}
        value={value}
        format="hex"
        onChange={onChange}
      />
    </StyledColorPickerContainer>
  )
}
export default Content
